import React from "react"
import { withStyles } from "@material-ui/core/styles"
import {
  Box,
  TextField,
  CssBaseline,
  Button,
  Snackbar,
  Typography, FormControl, InputLabel, Select, MenuItem
} from "@material-ui/core"
import Copyright from "../../commons/Copyright"
import PlatformRequest from "../../utils/PlatformRequest"
import Alert from "@material-ui/lab/Alert"
import { useHistory } from "react-router-dom"
import LoadPage from "../../components/LoadPage"
import Link from '@material-ui/core/Link'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Theme from "../../commons/Theme"
import logo from "../../assets/logo.jpeg"
import ModalDialog from "../../components/ModalDialog"
import CodeInput from "../../components/CodeInput"
import LockOpenIcon from '@material-ui/icons/LockOpen'
import {homePageStyles} from "../../utils/homePageStyles";

const RecoverPasswordPage = () => {
  const classes = homePageStyles()
  const history = useHistory()
  const [message, setMessage] = React.useState("")
  const [state, setState] = React.useState({
    login: "",
    open: false,
    vertical: "bottom",
    horizontal: "center",
  })
  const [load, setLoad] = React.useState(false)
  const [openModal, setOpenModal] = React.useState(false)
  const [openSuccessModal, setOpenSuccessModal] = React.useState(false)
  const { vertical, horizontal, open } = state
  const [code, setCode] = React.useState({ code: "", valid: false })
  const [errorPassword, setErrorPassword] = React.useState(false)
  const [accessType, setAccessType] = React.useState('PROVIDER')
  const [newPassword, setNewPassword] = React.useState({
    password: "",
    confirmPassword: ""
  })

  const verifySubmit = (event) => {
    if (event.key === "Enter") {
      submitResetPassword();
    }
  }

  const submitResetPassword = () => {
    setLoad(true);
    const { login } = state
    const resetBody = { login: login, rule: accessType }

    PlatformRequest.resetPasswordRequest(resetBody)
      .then((response) => {
        const { body } = response
        setLoad(false)
        setMessage(body.message)
        setOpenModal(true)
      })
      .catch(() => {
        setLoad(false)
        setState({ ...state, open: true })
      })

  }

  const resetPassword = () => {
    const { password, confirmPassword } = newPassword

    if (password !== confirmPassword) {
      return setErrorPassword(true)
    }

    if (!code.valid) {
      return
    }

    setOpenModal(false)
    setLoad(true)
    PlatformRequest.updatePassword({
      token: code.code,
      newPassword: password,
      confirmNewPassword: confirmPassword
    }).then(() => {
      setLoad(false)
      setOpenSuccessModal(true)
    }).catch(() => {
      setOpenModal(true)
      setLoad(false)
    })
  }

  const loginChange = (event) => {
    setState({
      ...state,
      login: event.target.value,
    })
  }

  const goToHome = () => {
    history.push("/")
  }

  const handleClose = () => {
    setState({ ...state, open: false });
  }

  const handleChange = (event) => {
    setAccessType(event.target.value)
  }

  const modalConfirmToken = (
    <ModalDialog
      title="Nova Senha"
      label="Redefinir Senha"
      open={openModal}
      textSave="Redefinir Senha"
      close={() => { setOpenModal(false) }}
      subTitle={message}
      saveMethod={resetPassword}
    >
      <Grid container direction="row" spacing={2}
        justify="flex-end">
        <Grid item>
          <CodeInput quantity={6} validCode={PlatformRequest.validateToken} receiveCode={setCode} />
        </Grid>
        <Grid item>
          <Link onClick={submitResetPassword} variant="body2">
            reenviar código
          </Link>
        </Grid>
      </Grid>
      <Grid container justify="center" direction="row" spacing={1}>
        <Grid item sm={12} xs={12} md={6}>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            type="password"
            error={errorPassword}
            label="Informe a nova senha"
            name="password"
            value={newPassword.password}
            onChange={(event) => { setNewPassword({ ...newPassword, password: event.target.value }) }}
          />
        </Grid>
        <Grid item sm={12} xs={12} md={6}>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            type="password"
            label="Confirme a nova senha"
            name="newPassword"
            error={errorPassword}
            helperText="As senhas precisam ser iguais"
            value={newPassword.confirmPassword}
            onChange={(event) => { setNewPassword({ ...newPassword, confirmPassword: event.target.value }) }}
          />
        </Grid>
      </Grid>

    </ModalDialog>
  )

  const modalSuccess = (
    <ModalDialog
      hiddenAction={true}
      open={openSuccessModal}>
      <Grid container direction="column" justifyContent="center" alignItems="center">
        <Grid>
          <LockOpenIcon style={{ fontSize: 60, color: "green" }} />
        </Grid>
        <Grid>
          <Typography variant="h6">
            Senha redefinida com sucesso!
          </Typography>
        </Grid>
        <Grid>
          <Button
            type="click"
            fullWidth
            variant="contained"
            color="primary"
            onClick={goToHome}
            className={classes.submit}
          >
            Acessar a pltaforma com a nova senha
          </Button>
        </Grid>
      </Grid>
    </ModalDialog>
  )

  return (
    <Theme>
      <Grid container component="main" className={classes.root}>
        <CssBaseline />
        <Grid item xs={false} sm={4} md={7} className={classes.image} />
        <Grid item xs={12} sm={8} md={5}
          component={Paper}
          elevation={6} square
          style={{ backgroundColor: "#14161FFF", paddingTop: 100 }}>
          <div className={classes.paper}>
            <img src={logo} alt="Deixa Que Eu Procuro" height="150" />
            <br /><br />
            <FormControl fullWidth variant="outlined" margin="normal" className={classes.select}>
              <InputLabel id="access-type-label">Acessar Como</InputLabel>
              <Select
                  labelId="access-type-label"
                  id="access-type-id"
                  value={accessType}
                  label="Acessar Como"
                  onChange={handleChange}
              >
                <MenuItem value={"PROVIDER"}>Fornecedor</MenuItem>
                <MenuItem value={"EMPLOYEE"}>Funcionário</MenuItem>
              </Select>
            </FormControl>
            <TextField
              variant="outlined"
              margin="normal"
              required
              autoFocus
              fullWidth
              id="login"
              onKeyDown={verifySubmit}
              label="Informe seu login de acesso"
              name="login"
              value={state.login}
              autoComplete="login"
              className={classes.textField}
              onChange={loginChange}
            />
            <Button
              type="click"
              fullWidth
              variant="contained"
              color="primary"
              onClick={submitResetPassword}
              className={classes.submit}
            >
              Enviar Código de Confirmação
            </Button>
            <Grid container>
              <Grid item xs>
              </Grid>
              <Grid item>
                <Link onClick={goToHome} component="button"
                  variant="body2">
                  acessar a plataforma
                </Link>
              </Grid>
            </Grid>
            <Box mt={5}>
              <Copyright />
            </Box>
          </div>
        </Grid>

        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={handleClose}
          key={vertical + horizontal}
        >
          <Alert onClose={handleClose} severity="error">
            Usuário não encontrado
          </Alert>
        </Snackbar>
        <LoadPage load={load} />
      </Grid>
      {modalConfirmToken}
      {modalSuccess}
    </Theme>
  )
}

export default withStyles(homePageStyles)(RecoverPasswordPage);
